<template>
  <div class="chat-session">
    <!-- 会话列表 -->
    <div class="session-list">
      <van-pull-refresh v-model="sessions.refreshing" :loading-text="$t('loading')" @refresh="onRefresh">
        <van-list v-model="sessions.loading" :finished="sessions.finished" :finished-text="$t('no_more_records')"
          :loading-text="$t('loading')" @load="onLoad">
          <div v-for="session in sessions.list" :key="session.chatSessionId" class="session-item"
            @click="onSessionClicked(session)">
            <!-- User Msg（优先展示，作为主内容） -->
            <div v-if="session.userMsg" class="session-user-msg">{{ $common.formatUserMsgPreview(session.userMsg) }}</div>
            <!-- AI Summary（系统匹配摘要） -->
            <div v-if="session.aiSummary" :class="['session-ai-summary', session.userMsg ? 'has-user-msg' : '']">
              <van-icon name="star-o" size="11" color="#8A8A8A" style="flex-shrink: 0; margin-top: 2px;" />
              <span class="session-ai-summary-text"><span style="color: #8A8A8A;">{{ $t('aiChat_matchSummaryLabel') }}: </span>{{ session.aiSummary }}</span>
            </div>

            <!-- Status Badges -->
            <div class="session-badges-row">
              <div v-if="session.requirementClarified == '1'" class="status-badge badge-clarified"
                :title="$t('title_needs_clarified')">
                <van-icon name="passed" size="10" />
                <span>{{ $t('badge_clarified') }}</span>
              </div>
              <div v-else class="status-badge badge-pending" :title="$t('title_clarifying')">
                <van-icon name="clock-o" size="10" />
                <span>{{ $t('badge_clarifying') }}</span>
              </div>
              
              <div v-if="session.public == '1'" class="status-badge badge-public" :title="$t('title_public')">
                <van-icon name="eye-o" size="10" />
                <span>{{ $t('badge_public') }}</span>
              </div>
              <div v-else class="status-badge badge-private" :title="$t('title_private')">
                <van-icon name="lock" size="10" />
                <span>{{ $t('badge_only_me') }}</span>
              </div>

              <div v-if="session.expired == '1'" class="status-badge badge-expired" :title="$t('title_expired')">
                <van-icon name="clock" size="10" />
                <span>{{ $t('badge_expired') }}</span>
              </div>
            </div>

            <!-- Footer: user avatar + user name + time -->
            <div class="session-footer">
              <div class="session-footer-left">
                <img v-if="currentUser.avatar" :src="$common.getFullImageUrl(currentUser.avatar, $config, 's')" class="session-footer-avatar">
                <div v-else class="session-footer-avatar-placeholder">
                  {{ (currentUser.userName || 'Me')[0] }}
                </div>
                <span class="session-footer-name">{{ currentUser.userName || 'Me' }}</span>
              </div>
              <span v-if="session.createdAt" class="session-footer-time">{{ $common.formatDateTime(session.createdAt) }}</span>
            </div>
          </div>

          <!-- Empty state -->
          <van-empty v-if="sessions.list.length === 0 && !sessions.loading" :description="$t('no_chat_history')" />
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import { List, PullRefresh, Empty, Icon, Toast, Dialog, Button } from 'vant'

Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Empty)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Button)

export default {
  name: 'ChatSession',
  props: {
    msg: String
  },
  data() {
    return {
      sessions: {
        loading: false,
        finished: false,
        refreshing: false,
        curPage: 1,
        pageSize: 20,
        list: []
      }
    }
  },
  computed: {
    beforeEatchInitialized() {
      return this.$store.state.beforeEatchInitialized;
    },
    currentUser() {
      return this.$store.state.user || {};
    },
  },
  watch: {
    beforeEatchInitialized(newValue) {
      if (newValue) {
        this.onRefresh()
      }
    },
  },
  mounted() {
    if (this.$store.state.beforeEatchInitialized) {
      this.onRefresh()
    }
  },
  methods: {
    onRefresh() {
      this.sessions.list = []
      this.sessions.curPage = 1
      this.sessions.finished = false
      this.sessions.refreshing = true
      this.onLoad()
    },

    onLoad() {
      let vm = this
      if (vm.sessions.finished) {
        vm.sessions.refreshing = false
        return
      }

      if (!vm.$common.getToken()) {
        vm.sessions.finished = true
        vm.sessions.loading = false
        vm.sessions.refreshing = false
        return
      }

      vm.sessions.loading = true

      var url = '/api/chat/pull_chat_sessions'
      var req = {
        curPage: vm.sessions.curPage,
        pageSize: vm.sessions.pageSize
      }

      axios.post(url, req).then(
        response => {
          vm.sessions.loading = false
          vm.sessions.refreshing = false

          var body = response.data
          if (body.code !== 0) {
            Toast.fail(vm.$t('toast_load_sessions_failed', {msg: body.msg}))
            vm.sessions.finished = true
            return
          }

          var data = body.data
          if (data.chatSessions && data.chatSessions.length > 0) {
            vm.sessions.list = vm.sessions.list.concat(data.chatSessions)
            if (data.chatSessions.length < data.pageSize) {
              vm.sessions.finished = true
            }
            vm.sessions.curPage = parseInt(data.curPage) + 1
          } else {
            vm.sessions.finished = true
          }
        }
      ).catch(error => {
        console.log(error)
        vm.sessions.loading = false
        vm.sessions.refreshing = false
        vm.sessions.finished = true
        Toast.fail(vm.$t('toast_load_sessions_error'))
      })
    },

    onSessionClicked(session) {
      // 跳转到聊天页面，携带 chatSessionId
      window.location.href = window.location.href.split('#')[0] + '#/?chatSessionId=' + session.chatSessionId
      window.location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chat-session {
  min-height: calc(100vh - 20px);
  background: #F7F5F2;
}

.session-list {
  overflow: hidden;
}

.session-item {
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin-bottom: 6px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
  cursor: pointer;
  transition: background-color 0.2s;
}

.session-item:active {
  background-color: #FAFAF8;
}

.session-user-msg {
  font-size: 14px;
  color: #1A1A1A;
  line-height: 1.5;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.session-ai-summary {
  display: flex;
  align-items: flex-start;
  gap: 3px;
  margin-top: 10px;
}

.session-ai-summary.has-user-msg {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(128, 128, 128, 0.15);
}

.session-ai-summary-text {
  font-size: 11px;
  color: #8A8A8A;
  line-height: 1.3;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.session-badges-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
}

/* Requirement Clarified 徽章 - 绿色 */
.badge-clarified {
  background: rgba(82, 196, 26, 0.1);
  color: #34A853;
}

/* Pending 徽章 - 橙色 */
.badge-pending {
  background: rgba(250, 173, 20, 0.1);
  color: #F5A623;
}

/* Public 徽章 - 蓝色 */
.badge-public {
  background: rgba(24, 144, 255, 0.1);
  color: #3DAECF;
}

/* Private 徽章 - 灰色 */
.badge-private {
  background: rgba(140, 140, 140, 0.1);
  color: #8A8A8A;
}

/* Expired 徽章 - 红色 */
.badge-expired {
  background: rgba(255, 77, 79, 0.1);
  color: #E05252;
}

.session-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.session-footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.session-footer-avatar {
  width: 28px;
  height: 28px;
  border-radius: 16%;
  object-fit: cover;
  flex-shrink: 0;
}

.session-footer-avatar-placeholder {
  width: 28px;
  height: 28px;
  border-radius: 16%;
  background: #E8543A;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.session-footer-name {
  font-size: 12px;
  color: #8A8A8A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.session-footer-time {
  font-size: 11px;
  color: #bbb;
  white-space: nowrap;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatSession.vue